<template>
  <nav class="sidebar-wrapper">
    <div class="sidebar-content">
      <div class="logo-panel d-flex align-items-center justify-content-between">
        <router-link :to="{ 'name': 'Dashboard' }" active-class="active">
<!--          <img src="/images/uxlove-logo-dark.svg" class="logo">-->
        </router-link>
      </div>
      <ul class="sidebar-menu ">
        <!--        <li v-for="(r,index) in routes" :key="index">-->
        <!--          <router-link :to="{'name': r.route}" active-class="active">-->
        <!--						<span class="icons">-->
        <!--							<span class="icon" :class="r.icon"></span>-->
        <!--						</span>-->
        <!--            <span class="text">{{r.text}}</span>-->
        <!--          </router-link>-->
        <!--        </li>-->
        <li>
          <router-link :to="{ 'name': 'Dashboard' }" active-class="active" exact>
            <span class="icons-holder">
              <span class="icon icon-chart-pie"></span>
            </span>
            <span class="text">{{ $static('nav.t1', 'Панелі') }}</span>
          </router-link>
        </li>
        <!--        <li class="cs">-->
        <!--          <a href="#">-->
        <!--            <span class="icons-holder">-->
        <!--							<span class="icon icon-2inst"></span>-->
        <!--						</span>-->
        <!--            <span class="text">{{$static('nav.t81', 'Інстаграм')}}</span>-->
        <!--            <div class="tip">-->
        <!--              <Popper arrow content="Coming Soon" hover placement="top">-->
        <!--                <span class="cs-trigger">?</span>-->
        <!--              </Popper>-->
        <!--            </div>-->
        <!--          </a>-->
        <!--        </li>-->

        <li>
          <router-link :to="{ 'name': 'Connect' }" active-class="active">
            <span class="icons-holder"><span class="icon icon-nav-bot"></span></span>
            <span class="text">{{ $static('nav.tcnt', 'Модулі') }}</span>
          </router-link>
        </li>
        <!--        <li>-->
        <!--          <router-link :to="{ 'name': 'AppInstagram' }" active-class="active">-->
        <!--            <span class="icons-holder"><span class="icon icon-2inst"></span></span>-->
        <!--            <span class="text">{{ $static('nav.t81', 'Інстаграм') }}</span>-->
        <!--          </router-link>-->
        <!--        </li>-->
        <li class="level-nav">
          <a href="javascript:void(0);" data-toggle="collapse" data-target="#level-menu2" class="with-drop">
            <span class="icons-holder">
              <span class="icon icon-apps"></span>
            </span>
            <span class="text">{{ $static('nav.t3', 'Каталог') }}</span>
          </a>
          <ul id="level-menu2" class="collapse">
            <li>
              <router-link :to="{ 'name': 'Categories' }" active-class="active">
                <span class="icons-holder">
                  <span class="icon icon-nav-categories"></span>
                </span>
                <span class="text">{{ $static('nav.t82', 'Категорії') }}</span>
              </router-link>
            </li>

            <li>
              <router-link :to="{ 'name': 'Catalog' }" active-class="active">
                <span class="icons-holder">
                  <span class="icon icon-nav-product"></span>
                </span>
                <span class="text">{{ $static('nav.t83', 'Товари') }}</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ 'name': 'Options' }" active-class="active">
                <span class="icons-holder">
                  <span class="icon icon-nav-options"></span>
                </span>
                <span class="text">{{ $static('nav.t2', 'Опції') }}</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ 'name': 'SettingsOptions' }" active-class="active">
                <span class="icons-holder">
                  <span class="icon icon-nav-options-setting"></span>
                </span>
                <span class="text">{{ $static('nav.t77', 'Налаштування опцій') }}</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ 'name': 'CatalogMenuFilter' }" active-class="active">
                <span class="icons-holder">
                  <span class="icon icon-nav-filter"></span>
                </span>
                <span class="text">{{ $static('nav.catmenfil', 'Меню та Фільтри') }}</span>
              </router-link>
            </li>
            <!--            <li>-->
            <!--              <router-link :to="{'name': 'Tags'}" active-class="active">-->
            <!--                <span class="text">Фільтр по тегам</span>-->
            <!--              </router-link>-->
            <!--            </li>-->
          </ul>
        </li>

        <li>
          <router-link :to="{ 'name': 'Orders' }" active-class="active">
            <span class="icons-holder">
              <span class="icon icon-shopping-basket"></span>
            </span>
            <span class="text">{{ $static('nav.t4', 'Замовлення') }}</span>
            <span class="notification" v-if="orderCount > 0">{{ orderCount }}</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ 'name': 'Leads' }" active-class="active">
            <span class="icons-holder">
              <span class="icon icon-nav-leads"></span>
            </span>
            <span class="text">{{ $static('nav.t100', 'Заявки') }}</span>
            <span class="notification" v-if="leadCount > 0">{{ leadCount }}</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ 'name': 'Landings' }" active-class="active">
            <span class="icons-holder">
              <span class="icon icon-nav-landings"></span>
            </span>
            <span class="text">{{ $static('nav.t101', 'Landings') }}</span>
          </router-link>
        </li>
<!--        <li>-->
<!--          <router-link :to="{ 'name': 'Chat' }" active-class="active">-->
<!--            <span class="icons-holder">-->
<!--              <span class="icon icon-chat"></span>-->
<!--            </span>-->
<!--            <span class="text">{{ $static('nav.t79', 'Чат з клієнтами') }}</span>-->
<!--          </router-link>-->
<!--        </li>-->
        <!-- <li class="cs">
          <a href="#">
            <span class="icons-holder">
              <span class="icon icon-chat"></span>
            </span>
            <span class="text">{{ $static('nav.t79', 'Чат з клієнтами') }}</span>
            <div class="tip">
              <Popper arrow content="Coming Soon" hover placement="top">
                <span class="cs-trigger">?</span>
              </Popper>
            </div>
          </a>
        </li> -->


        <li class="level-nav">
          <a href="javascript:void(0);" data-toggle="collapse" data-target="#level-menu3" class="with-drop">
            <span class="icons-holder">
              <span class="icon icon-2processor"></span>
            </span>
            <span class="text">{{ $static('nav.t78', 'Налаштування бота') }}</span>
          </a>
          <ul id="level-menu3" class="collapse">
            <li>
              <router-link :to="{ 'name': 'SettingsMessages' }" active-class="active">
                <span class="icons-holder">
                  <span class="icon icon-nav-start-message"></span>
                </span>
                <span class="text">{{ $static('nav.t74', 'Стартове повідомлення') }}</span>
              </router-link>
            </li>
            <li class="level-nav sub-level-nav">
              <a href="javascript:void(0);" data-toggle="collapse" data-target="#sub-level1"
                class="sub-level-collapse with-drop">
                <span class="icons-holder">
                  <span class="icon icon-nav-auditory"></span>
                </span>
                <span class="text">{{ $static('nav.t84', 'Аудиторії') }}</span>
              </a>
              <ul id="sub-level1" class="collapse">
                <li>
                  <router-link :to="{ 'name': 'Users' }" active-class="active">
                    <span class="icons-holder">
                      <span class="icon icon-nav-user-follow"></span>
                    </span>
                    <span class="text">{{ $static('nav.t5', 'Покупці') }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ 'name': 'Subscribers' }" active-class="active">
                    <span class="icons-holder">
                      <span class="icon icon-nav-server"></span>
                    </span>
                    <span class="text">{{ $static('nav.t85', 'Вся база') }}</span>
                    <!--                    <div class="tip" style="white-space: nowrap">-->
                    <!--                      <Popper arrow content="Coming Soon" hover placement="top">-->
                    <!--                        <span class="cs-trigger">?</span>-->
                    <!--                      </Popper>-->
                    <!--                    </div>-->
                  </router-link>
                </li>
                <li class="cs">
                  <a href="#">
                    <span class="icons-holder">
                      <span class="icon icon-nav-user-setting"></span>
                    </span>
                    <span class="text">{{ $static('nav.t86', 'Налаштовувані аудиторії') }}</span>
                    <div class="tip">
                      <Popper arrow content="Coming Soon" hover placement="top">
                        <span class="cs-trigger">?</span>
                      </Popper>
                    </div>
                  </a>
                </li>
              </ul>
            </li>
            <li class="level-nav sub-level-nav">
              <a href="javascript:void(0);" data-toggle="collapse" data-target="#sub-level2"
                class="sub-level-collapse with-drop">
                <span class="icons-holder">
                  <span class="icon icon-nav-sends"></span>
                </span>
                <span class="text">{{ $static('nav.t87', 'Розсилки') }}</span>
              </a>
              <ul id="sub-level2" class="collapse">
                <li>
                  <router-link :to="{ 'name': 'Multisend' }" active-class="active">
                    <span class="icons-holder">
                      <span class="icon icon-nav-stack"></span>
                    </span>
                    <span class="text">{{ $static('nav.t6', 'Загальні розсилки') }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ 'name': 'MultisendBusked' }" active-class="active">
                    <span class="icons-holder">
                      <span class="icon icon-nav-backspace"></span>
                    </span>
                    <span class="text">{{ $static('nav.t88', 'Покинутий кошик') }}</span>
                    <!--                    <div class="tip">-->
                    <!--                      <Popper arrow content="Coming Soon" hover placement="top">-->
                    <!--                        <span class="cs-trigger">?</span>-->
                    <!--                      </Popper>-->
                    <!--                    </div>-->
                  </router-link>
                </li>
                <li class="cs">
                  <a href="#">
                    <span class="icons-holder">
                      <span class="icon icon-nav-bullhorn"></span>
                    </span>
                    <span class="text">{{ $static('nav.t89', 'Маркетингові розсилки') }}</span>
                    <div class="tip">
                      <Popper arrow content="Coming Soon" hover placement="top">
                        <span class="cs-trigger">?</span>
                      </Popper>
                    </div>
                  </a>
                </li>
                <li class="cs">
                  <a href="#">
                    <span class="icons-holder">
                      <span class="icon icon-nav-targets"></span>
                    </span>
                    <span class="text">{{ $static('nav.t90', 'Воронки') }}</span>
                    <div class="tip">
                      <Popper arrow content="Coming Soon" hover placement="top">
                        <span class="cs-trigger">?</span>
                      </Popper>
                    </div>
                  </a>
                </li>
                <li class="cs">
                  <a href="#">
                    <span class="icons-holder">
                      <span class="icon icon-nav-bot"></span>
                    </span>
                    <span class="text">{{ $static('nav.t91', 'Чат-боти') }}</span>
                    <div class="tip">
                      <Popper arrow content="Coming Soon" hover placement="top">
                        <span class="cs-trigger">?</span>
                      </Popper>
                    </div>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <!--        <li>-->
        <!--          <router-link :to="{'name': 'CallBack'}" active-class="active">-->
        <!--						<span class="icons">-->
        <!--							<span class="icon icon-2phone"></span>-->
        <!--						</span>-->
        <!--            <span class="text">Обратный звонок</span>-->
        <!--            <span class="notification" v-if="callBackCount > 0">{{callBackCount}}</span>-->
        <!--          </router-link>-->
        <!--        </li>-->
        <!--        <li>-->
        <!--          <router-link :to="{'name': 'Landing'}" active-class="active">-->
        <!--						<span class="icons">-->
        <!--							<span class="icon icon-print"></span>-->
        <!--						</span>-->
        <!--            <span class="text">Landing Page</span>-->
        <!--          </router-link>-->
        <!--        </li>-->
        <!--<li>
          <router-link :to="{'name': 'Settings'}" active-class="active">
						<span class="icons">
							<span class="icon icon-settings"></span>
						</span>
            <span class="text">Настройки</span>
          </router-link>
        </li>-->
        <li class="level-nav">
          <a href="javascript:void(0);" data-toggle="collapse" data-target="#level-menu" class="with-drop">
            <span class="icons-holder">
              <span class="icon icon-settings"></span>
            </span>
            <span class="text">{{ $static('nav.t7', 'Глобальні настройки') }}</span>
          </a>
          <ul id="level-menu" class="collapse">
            <li>
              <router-link :to="{ 'name': 'SettingsBasic' }" active-class="active">
                <span class="icons-holder">
                  <span class="icon icon-nav-store"></span>
                </span>
                <span class="text">{{ $static('nav.t71', 'Налаштування магазину') }}</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ 'name': 'SettingsPayments' }" active-class="active">
                <span class="icons-holder">
                  <span class="icon icon-2wallet"></span>
                </span>
                <span class="text">{{ $static('nav.t75', 'Налаштування оплати') }}</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ 'name': 'SettingsDeliveries' }" active-class="active">
                <span class="icons-holder">
                  <span class="icon icon-nav-box"></span>
                </span>
                <span class="text">{{ $static('nav.t76', 'Налаштування доставки') }}</span>
              </router-link>
            </li>

            <li>
              <router-link :to="{ 'name': 'Options', params: { 'option_id': 'ingredient' } }" active-class="active">
                <span class="icons-holder">
                  <span class="icon icon-nav-ingredients"></span>
                </span>
                <span class="text">{{ $static('nav.tt91', 'Позначки ') }}</span>
              </router-link>
            </li>

            <li>
              <router-link :to="{ 'name': 'SettingsPage' }" active-class="active">
                <span class="icons-holder">
                  <span class="icon icon-nav-file"></span>
                </span>
                <span class="text">{{ $static('nav.t72-', 'Сторінки та Popup') }}</span>
              </router-link>
            </li>

            <li>
              <router-link :to="{ 'name': 'Translate' }" active-class="active">
                <span class="icons-holder">
                  <span class="icon icon-2translate"></span>
                </span>
                <span class="text">{{ $static('nav.t9', 'Переклади') }}</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ 'name': 'Reviews' }" active-class="active">
                <span class="icons-holder">
                  <svg class="icon icon-2review" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd"
                    clip-rule="evenodd" viewBox="0 0 26 26">
                    <path
                      d="M20 15c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1m-3 0c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1m-3 0c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1m5.415 4.946c-1 .256-1.989.482-3.324.482-3.465 0-7.091-2.065-7.091-5.423 0-3.128 3.14-5.672 7-5.672 3.844 0 7 2.542 7 5.672 0 1.591-.646 2.527-1.481 3.527l.839 2.686-2.943-1.272zm-13.373-3.375l-4.389 1.896 1.256-4.012c-1.121-1.341-1.909-2.665-1.909-4.699 0-4.277 4.262-7.756 9.5-7.756 5.018 0 9.128 3.194 9.467 7.222-1.19-.566-2.551-.889-3.967-.889-4.199 0-8 2.797-8 6.672 0 .712.147 1.4.411 2.049-.953-.126-1.546-.272-2.369-.483m17.958-1.566c0-2.172-1.199-4.015-3.002-5.21l.002-.039c0-5.086-4.988-8.756-10.5-8.756-5.546 0-10.5 3.698-10.5 8.756 0 1.794.646 3.556 1.791 4.922l-1.744 5.572 6.078-2.625c.982.253 1.932.407 2.85.489 1.317 1.953 3.876 3.314 7.116 3.314 1.019 0 2.105-.135 3.242-.428l4.631 2-1.328-4.245c.871-1.042 1.364-2.384 1.364-3.75" />
                  </svg>

                </span>
                <span class="text">{{ $static('????', 'Відгуки') }}</span> <!--fix static content-->
              </router-link>
            </li>
            <li>
              <router-link :to="{ 'name': 'SettingsPassword' }" active-class="active">
                <span class="icons-holder">
                  <span class="icon icon-nav-key"></span>
                </span>
                <span class="text">{{ $static('nav.p11', 'Зміна паролю') }}</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ 'name': 'SettingsApi' }" active-class="active">
                <span class="icons-holder">
                  <span class="icon icon-nav-api"></span>
                </span>
                <span class="text">{{ $static('nav.t73', 'API') }}</span>
              </router-link>
            </li>

          </ul>
        </li>

        <li>
          <router-link :to="{ 'name': 'AdminSupport' }" active-class="active">
            <span class="icons-holder">
              <span class="icon icon-2support"></span>
            </span>
            <span class="text">{{ $static('nav.e1', 'Підтримка') }}</span>
          </router-link>
        </li>
      </ul>
      <div class="divider">
        <span></span>
      </div>
      <div class="lang-holder">
        <div class="lang-body">
          <div class="lang-label">{{ $static('nav.lang', 'Виберіть мову') }}</div>
          <div class="dropdown lang-panel">
            <button class="dropdown-toggle" type="button" id="dropdownMenuLang" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <img :src="current.icon" :alt="current.text"><span>{{ current.text }}</span>
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuLang">
              <li v-for="(l, index) in lang" :key="index">
                <a href="javascript:void(0)" @click="setLang(l)" :class="{ 'active': l.text === current.text }">
                  <img :src="l.icon" :alt="l.text">
                  <span>{{ l.text }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--      <div class="billing-nav" style="display:none;">-->
      <!--        <ul class="sidebar-menu ">-->
      <!--          <li class="level-nav">-->
      <!--            <a href="javascript:void(0);" data-toggle="collapse" data-target="#level-menu2">-->
      <!--              <span class="icons">-->
      <!--                <span class="icon icon-2credit-card"></span>-->
      <!--              </span>-->
      <!--              <span class="text">Billing panel</span>-->
      <!--            </a>-->
      <!--            <ul id="level-menu2" class="collapse">-->
      <!--              <li>-->
      <!--                <a href="#">Мой тариф</a>-->
      <!--              </li>-->
      <!--              <li>-->
      <!--                <a href="#">Мои счета</a>-->
      <!--              </li>-->
      <!--              <li>-->
      <!--                <a href="#">Платежные данные</a>-->
      <!--              </li>-->

      <!--            </ul>-->
      <!--          </li>-->
      <!--        </ul>-->
      <!--      </div>-->


    </div>
    <div class="nav-bottom">
      <div class="copy-and-soc">

        <div class="copyright">
          &copy; {{(new Date()).getFullYear()}}
        </div>
        <div class="soc-icons">
          <a href="#">
            <img src="/images/icons/telegram-filled.svg">
          </a>
          <a href="#">
            <img src="/images/icons/instagram-filled.svg">
          </a>
        </div>
      </div>
      <div class="dev_by d-flex align-items-center">
<!--        <div class="name">Developed by</div>-->
<!--        <a href="#"><img src="/images/logo-dark.svg" alt="uxlove studio"></a>-->
      </div>
    </div>
    <div class="logout">
      <a href="javascript:void(0)" @click.prevent.stop="logout">
        <span class="icons">
          <span class="icon icon-power"></span>
        </span>
        <span class="text">{{ $static('nav.logout', 'Вихід з панелі') }}</span>
      </a>
    </div>
    <img src="/images/menu-bg1.png" alt="" class="menubg1 menubg">
    <img src="/images/menu-bg2.png" alt="" class="menubg2 menubg">
  </nav>
</template>
<script>
import api from '@/api'

export default {
  name: 'AdminNav',

  methods: {
    setLang(lang) {
      this.current = lang;
      this.fetchLang();
      location.reload();
    },
    fetchLang() {
      fetch(this.current.url).then(response => response.json()).then(data => {
        if (data) {
          localStorage.setItem('$lang', this.current.short);
          this.$load(data, this.current.short)

        }
      })
    },
    fetchOrigin() {
      return fetch(this.current.url).then(response => response.json()).then(data => {
        if (data) {
          this.$load(data, this.current.short)
        }
      })
    },
    logout() {
      api.get('/auth/logout')
        .then(
          () => {
            this.$router.push({ name: 'Login' })
          }
        )
    },
    callBackCountRefresh() {
      if (this.$router.currentRoute.name !== 'Login') {
        api.get('/api/notification').then(response => response.data).then(data => {
          this.callBackCount = data.callback_count;
          this.orderCount = data.new_order_count;
          this.leadCount = data.new_lead_count;
        })
      }
    }

  },
  computed: {
    // routers() {
    //   return this.$router.options.routes
    // },
    settings() {
      return this.$store.getters.settings
    },
    logoSrc() {
      return this.settings.public.logo ? this.settings.public.logo : '/storage/logo-cryox.svg'
    }
  },
  mounted() {
    this.callBackCountRefresh();
    if (this.callBackTick === undefined) {
      this.callBackTick = setInterval(this.callBackCountRefresh, 10000)
    }

    this.fetchOrigin().then(() => {
      const lang = localStorage.getItem('$lang');
      if (lang) {
        let x = this.lang.find(i => i.short === lang);
        if (x) {
          this.current = x;
          this.fetchLang()
        }
      }
    });
  },
  beforeUnmount() {
    if (this.callBackTick) {
      clearInterval(this.callBackTick)
    }
    this.callBackTick = undefined
  },
  data() {
    return {
      callBackCount: 0,
      orderCount: 0,
      leadCount: 0,
      callBackTick: undefined,
      current: {
        icon: '/images/icons/ukraine.svg',
        text: 'Ua',
        short: 'ua',
        url: '/storage/i18n/original.admin.json'
      },
      lang: [
        {
          icon: '/images/icons/ukraine.svg',
          text: 'Ua',
          short: 'ua',
          url: '/storage/i18n/original.admin.json'
        },
        {
          icon: '/images/icons/states.svg',
          text: 'En',
          short: 'en',
          url: '/storage/i18n/en.admin.json'
        },
        {
          icon: '/images/icons/r.svg',
          text: 'Язык',
          short: 'ru',
          url: '/storage/i18n/ru.admin.json'
        }
      ]
    }
  }
}
</script>
